<template>
  <div class="main__div">
    <!-- <login v-if="$store.state.Auth.checkStatus == 'LOGIN'" />
    <VerifyOtp v-if="$store.state.Auth.checkStatus == 'OTP'" />
    <profile v-if="$store.state.Auth.checkStatus == 'PROFILE'" /> -->
    <v-main>
      <router-view></router-view>
    </v-main>
  </div>
</template>
<script>
// import login from "@/components/Authentication/login.vue";
// import VerifyOtp from "@/components/Authentication/VerifyOtp.vue";
// import Profile from "../../components/Authentication/Profile.vue";
export default {
  name: "AuthPage",
  // components: {
  //   login: login,
  //   VerifyOtp: VerifyOtp,
  //   profile: Profile,
  // },
  metaInfo: {
    title: "Login",
  },
  mounted() {
    // authToken.isAuthenticated();
    // if(authToken.isTokenValid()
  },
};
</script>

<style scoped>
.main__div {
  min-height: 80vh;
  background: #fff;
}

@media all and (max-width: 600px) {
  .main__div {
    min-height: 100vh;
  }
}
</style>
